var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-card-discover"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-discover",
    clipPath: "url(#clip-card-discover)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discover-network",
    transform: "translate(-23.697 -17.195)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10787",
    "data-name": "Ellipse 10787",
    cx: 9.998,
    cy: 9.998,
    r: 9.998,
    transform: "translate(28.7 22.2)",
    fill: "#ef9122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33624",
    "data-name": "Path 33624",
    d: "M28.7,32.2a10,10,0,1,1,10,10",
    transform: "translate(0 0)",
    fill: "#f26e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33625",
    "data-name": "Path 33625",
    d: "M30.3,25.084A9.924,9.924,0,0,1,44.335,39.119",
    transform: "translate(1.476)",
    fill: "#f44500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDiscover);
export default __webpack_public_path__ + "static/media/card-discover.67f0453fdbcc631617b0c533bbcc8f67.svg";
export { ForwardRef as ReactComponent };